export default __webpack_public_path__ + "static/media/percorso-pescatori.54cdacf7.jpg";